import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import ExchangeTag from '../../Common/ExchangeTag';

const formatExpiryDate = (epochTimestamp) => {
  try {
    const timestamp = epochTimestamp.toString().length === 10 ? 
      epochTimestamp * 1000 : epochTimestamp;
    return format(new Date(timestamp), 'dd MMM yyyy');
  } catch (err) {
    console.error('Error formatting expiry date:', err);
    return epochTimestamp;
  }
};

const InstrumentInfo = ({ instrument }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: "medium" }}>
          {instrument.display_name}
        </Typography>
        <ExchangeTag exchange={instrument.exchange} />
      </Box>
      {/* Show company name for CDS instruments */}
      {(instrument.exchange === "CDS" || instrument.exchange === "DCSX") && instrument.company_name && (
        <Typography variant="caption" color="text.secondary">
          {instrument.company_name}
        </Typography>
      )}
      {(instrument.exchange === "NFO" || instrument.exchange === "MCX" || instrument.exchange === "BFO") &&
        instrument.expiry &&
        (!instrument.execution || instrument.execution !== "SPREAD") && (
          <Typography variant="caption" color="text.secondary">
            Expiry: {formatExpiryDate(instrument.expiry)}
          </Typography>
        )}
      {(instrument.exchange === "NSE" || instrument.exchange === "BSE") && instrument.description && (
        <Typography variant="caption" color="text.secondary">
          {instrument.description}
        </Typography>
      )}
    </Box>
  );
};

export default InstrumentInfo; 